import { render, staticRenderFns } from "./LegoViewInModalCrearTablero.vue?vue&type=template&id=654d8c97&scoped=true"
import script from "./LegoViewInModalCrearTablero.vue?vue&type=script&lang=js"
export * from "./LegoViewInModalCrearTablero.vue?vue&type=script&lang=js"
import style0 from "./LegoViewInModalCrearTablero.vue?vue&type=style&index=0&id=654d8c97&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "654d8c97",
  null
  
)

export default component.exports